import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api, { setAuthToken, setRefreshToken } from "../dashboard/api";
import "../dashboard/dashboard.css";

export default function Login() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    api
      .get("/api/user/role/", { headers: { Authorization: `Bearer ${token}` } })
      .then(() => nav("/dashboard", { replace: true }))
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
      });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const { data } = await api.post("/api/token/", { username, password });
      localStorage.setItem("token", data.access);
      localStorage.setItem("refresh", data.refresh);
      setAuthToken(data.access);
      setRefreshToken(data.refresh);
      nav("/dashboard", { replace: true });
    } catch (e) {
      setErr("Rangt notendanafn eða lykilorð.");
    }
  };

  return (
    <div className="dash-page">
      <header className="dash-header">
        <div className="dash-brand">
          <div className="dash-logo" />
          <div className="dash-title">Innskráning</div>
        </div>
      </header>

      <main className="dash-content" style={{ maxWidth: 420 }}>
        <form className="card" onSubmit={submit} style={{ padding: 20 }}>
          <div className="field">
            <span>Notendanafn</span>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
          </div>

          <div className="field" style={{ marginTop: 12 }}>
            <span>Lykilorð</span>

            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: "100%", paddingRight: 44 }}
              />

              <button
                type="button"
                aria-label={showPassword ? "Fela lykilorð" : "Sýna lykilorð"}
                title={showPassword ? "Fela lykilorð" : "Sýna lykilorð"}
                onMouseEnter={() => setShowPassword(true)}
                onMouseLeave={() => setShowPassword(false)}
                onMouseDown={() => setShowPassword(true)}
                onMouseUp={() => setShowPassword(false)}
                onTouchStart={() => setShowPassword(true)}
                onTouchEnd={() => setShowPassword(false)}
                onTouchCancel={() => setShowPassword(false)}
                style={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: 18,
                  padding: 4,
                  lineHeight: 1,
                }}
              >
                👁
              </button>
            </div>
          </div>

          {err ? (
            <div className="error" style={{ marginTop: 10 }}>
              {err}
            </div>
          ) : null}

          <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
            <button className="btn" type="submit">
              Innskrá
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}